<app-global-info
  icon="mdi-cloud-lock-outline"
  [title]="'notfound.title' | translate"
  [description]="'notfound.text' | translate"
  [showButton]="true"
  [buttonText]="'notfound.actions.try-again' | translate"
  (clicked)="navigateBack()"
></app-global-info>
